<template>
  <div>
    <WithTableData v-slot="{ headers, loading }" :Model="Model">
      <ManageBaseTable
        :headers="headers"
        :loading="loading"
        :sort-by="sortBy"
        :Model="Model"
        @show-snack="(color, text) => showSnack(color, text)"
      />
    </WithTableData>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor"
      ><h2>{{ snackText }}</h2></v-snackbar
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { Model } from '@vuex-orm/core'

import ManageBaseTable from '@/components/ManageBaseTable'
import WithTableData from '@/components/DataProviders/WithTableData'

export default {
  name: 'ManageIndexView',
  components: {
    WithTableData,
    ManageBaseTable,
  },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
  },
  meta() {
    return { title: `${this.modelName} | Minimart` }
  },
  data() {
    return {
      snack: false,
      snackColor: '',
      snackText: '',
    }
  },
  created() {
    this.fetchShopById()
  },
  methods: {
    ...mapActions('shop', ['fetchShopById']),
    // Dialog actions for provide/inject
    close() {
      this.showSnack('info', 'Closed without saving.')
    },
    cancel() {
      this.showSnack('warn', 'Canceled edit.')
    },
    open() {
      this.showSnack('info', 'Press Enter to Save.')
    },
    saved() {
      this.showSnack('success', 'Saved')
    },
    showSnack(color, text) {
      this.snack = true
      this.snackColor = color
      this.snackText = text
    },
  }, // methods

  provide() {
    return {
      close: this.close,
      cancel: this.cancel,
      open: this.open,
      saved: this.saved,
    }
  },
  computed: {
    ...mapGetters('shop', [
      'getShopTitle',
      'getDeliverySlots',
      'getPickupSlots',
      'getFulfillmentOptions',
      'getFulfillmentSlotsList',
    ]),
    ...mapFields('admin', ['tableItems']),
    ...mapFields('admin', {
      sortBy: 'tableMeta.sortBy',
    }),
    basePath() {
      let uri_path = this.Model.uri_path ?? this.Model.entity
      return `/settings/${uri_path}`
    }, // basePath
    modelName() {
      return this.Model.namePlural
    },
  },
}
</script>

<style lang="scss">
.mm-base-table.v-data-table {
  th {
    font-size: 0.9rem;
    font-weight: 700;
    justify-content: baseline;
  }
  tr td {
    border-left: thin solid rgba(0, 0, 0, 0.12);
    &:last-child {
      border-right: thin solid rgba(0, 0, 0, 0.12);
    }
  }
  > .v-data-table__wrapper > table > tbody > tr > td {
    padding-left: 8px;
    padding-right: 8px;
  }
}

.handle {
  cursor: move !important;
  cursor: -webkit-grab !important;
}
</style>
